export default __webpack_public_path__ + "static/media/SAS Alert Tone 12.cda3ce8a.mp3";